
import {serviceApprovedConstants} from './constants.js';
export default function serviceApprovedReducer(state={
    myServicesApproval: {},
    fetched: false,
    loadingSearch:false,
    loading:false,
    saved:false,
  }, action) {

    state = {...state,saved:{...state.saved ,serviceStart:false},loading:{...state.loading ,getService:false }}
    switch (action.type) {



        case serviceApprovedConstants.GET_ALL_MY_SERVICE_APPROVAL_APPROVED_PENDING: {
            return {...state,loading:{...state.loading ,getService:false }, user: action.payload,saved:false}
        }  
        case  serviceApprovedConstants.GET_ALL_MY_SERVICE_APPROVAL_APPROVED_FULFILLED: {
            return {...state,loading:{...state.loading ,getService:false }, myServicesApproval:action?.payload?.data?.data}
        }    
        case serviceApprovedConstants.GET_ALL_MY_SERVICE_APPROVAL_APPROVED_FAILURE:  {
            return {...state, loading:{...state.loading ,getService:false },error:action.error}
        }
        case serviceApprovedConstants.GET_ALL_MY_SERVICE_APPROVAL_APPROVED_REJECTED:  {
            return {...state, loading:{...state.loading ,getService:false },error:action.payload}
        }

        
        case serviceApprovedConstants.SAVE_SERVICE_APPROVAL_APPROVED_PENDING: {
            return {...state,loading:{...state.loading , saveServiceReport:true },save:{...state.save , saveServiceReport:false } ,}
        }  
        case  serviceApprovedConstants.SAVE_SERVICE_APPROVAL_APPROVED_FULFILLED: {
            return {...state,loading:{...state.loading , saveServiceReport:false } ,save:{...state.save , saveServiceReport:true } , serviceReport:action?.payload?.data?.data}
        }    
        case serviceApprovedConstants.SAVE_SERVICE_APPROVAL_APPROVED_FAILURE:  {
            return {...state, loading:{...state.loading , saveServiceReport:false } ,save:{...state.save , saveServiceReport:false } ,error:action.error}
        }
        case serviceApprovedConstants.SAVE_SERVICE_APPROVAL_APPROVED_REJECTED:  {
            return {...state, loading:{...state.loading , saveServiceReport:false } ,save:{...state.save , saveServiceReport:false } ,error:action.payload}
        }

        case serviceApprovedConstants.SAVE_FALSE :  {
            return {...state,save:{...state.save , 
                    
                     saveServiceReport:false } 
                      ,error:{}}
        }
       
        default :
            return state;
    }


}
